import { Theme } from '@mui/material'

export const getThemeStylesForRangeSlider = (theme: Theme) => ({
    'cursor': 'default',
    'marginTop': 6,
    '& .MuiSlider-thumb': {
        color: theme.palette.primary.main,
        width: 8,
        height: 8
    },
    '& .MuiSlider-track': {
        color: theme.palette.primary.main,
        height: '1px'
    },
    '& .MuiSlider-rail': {
        height: 2,
        background: `linear-gradient(90deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 26.5%, ${theme.palette.primary.main} 78.5%, ${theme.palette.primary.light} 100%)`,
        opacity: 1
    },
    '& .MuiSlider-mark': {
        display: 'none'
    },
    '& .MuiSlider-markLabel': {
        'backgroundColor': theme.palette.common.black,
        'color': theme.palette.common.white,
        'padding': theme.spacing(0.5, 1.25),
        'borderRadius': theme.shape.borderRadius,
        'fontSize': theme.typography.body2.fontSize,
        'fontWeight': theme.typography.fontWeightMedium,
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            left: '50%',
            marginLeft: '-5px',
            borderWidth: '5px',
            borderStyle: 'solid',
            borderColor: `${theme.palette.common.black} transparent transparent transparent`
        }
    },
    '& .MuiSlider-markLabel[data-index="0"], & .MuiSlider-markLabel[data-index="2"]':
        {
            'background': 'none',
            'color': theme.palette.primary.main,
            'transform': 'translateX(-50%) translateY(0px)',
            '&::after': {
                display: 'none'
            }
        },
    '& .MuiSlider-markLabel[data-index="1"]': {
        transform: 'translateX(-50%) translateY(-60px)'
    }
})
